import { render, staticRenderFns } from "./index.vue?vue&type=template&id=38ed449c&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/nisems/front/nisbos-front-admin/project/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ed449c')) {
      api.createRecord('38ed449c', component.options)
    } else {
      api.reload('38ed449c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=38ed449c&", function () {
      api.rerender('38ed449c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RightToolbar/index.vue"
export default component.exports